import Vue from 'vue'
import Vuex from 'vuex'
import PianoAnalytics from 'piano-analytics-js'
import config from '@/config'

Vue.use(Vuex)

const initialState = {
  tag: undefined,
  isLoad: false,
  pa: null
}

const getters = {
  getAtInternetTag: state => state.tag,
  isLoad: state => state.isLoad,
  getPianoAnalytics: state => state.pa
}

const mutations = {
  setAtInternetTag: (state) => {
    if (window.ATInternet) {
      state.tag = new window.ATInternet.Tracker.Tag({ secure: true })
      state.isLoad = true
    }
  },
  setPianoAnalytics: (state) => {
    if (config.PIANO_ANALYTICS_DOMAIN) {
      // Determine which site ID to use based on environment
      const siteId = config.ENV_NAME === 'prod'
        ? config.PIANO_ANALYTICS_SITE_ID_PROD
        : config.PIANO_ANALYTICS_SITE_ID_DEV

      if (siteId) {
        const pa = PianoAnalytics.getInstance()
        pa.setConfigurations({
          site: siteId,
          collectDomain: config.PIANO_ANALYTICS_DOMAIN
        })
        state.pa = pa
        state.isLoad = true
      }
    }
  }
}

const actions = {
  sendEvent({ state, getters }, payload) {
    // Legacy AT Internet support
    if (getters.isLoad && state.tag) {
      state.tag.events.send(payload.name, payload.info)
    }
    // Piano Analytics support
    if (state.pa) {
      state.pa.sendEvent(payload.name, payload.info)
    }
  },
  triggerLocation({ dispatch }, location) {
    dispatch('sendEvent', { name: 'page.display', info: { page: location } })
  },
  triggerScroll({ dispatch }, location) {
    dispatch('sendEvent', { name: 'feed.scroll', info: { page: location } })
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
